import React, { useState, useEffect, useRef } from "react";
import { WebService } from "../../Services/WebService";
import AddEditJobFunction from "./AddEditJobFunction";
import { useDispatch, useSelector } from "react-redux";
import "./Static.css";
import { ActionPermission, PageInfo } from "../PageInfo";
import SnackbarComponent from "../../Services/SnackbarComponent";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import "../Static/Static.css";
import ActionButton from "../../Services/ActionButton";
import StaticListComponent from "../../Services/StaticListComponent";
import { NoRecordTemplate } from "../../Services/TableComponent";
import Button from "react-bootstrap/esm/Button";
import { StandardConst } from "../../Services/StandardConst";
import { statusUpdate as ConfigurationflowStatusUpdate } from "../../Services/ConfigurationFlow";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { IconButton } from "@mui/material";
import AssignStandardKRAToJobFunctionComponent from "../Company/JobFunction/AssignStandardKRAToJobFunctionComponent";
import { useLocation } from "react-router-dom";


const JobFunction = () => {
  const { state } = useLocation();
  const ref = useRef();
  const assignStandardKRAToJobFunctionRef = useRef();
  const refSnackbar = useRef();
  PageInfo({ pageTitle: "Manage Job Functions" });
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);

  const [permission, SetPermission] = useState({});
  const permissionList = useSelector((s) => s.auth.PermissionList??[]);
  useEffect(() => {
    SetPermission({
      ManageAdd: ActionPermission("Job Function - Add"),
      ManageEdit: ActionPermission("Job Function - Edit"),
      ManageDelete: ActionPermission("Job Function - Delete"),
    });
  }, [permissionList]);

  const fetchJobFunction = async () => {
    const data = await WebService({ endPoint: "JobFunction/Fetch", dispatch });
    setRecords(data);
    dispatch(ConfigurationflowStatusUpdate());
  };

  const onDelete = async (JobFunctionId) => {
    await WebService({
      endPoint: `CommonUtility/staticjobfunctions?JobFunctionId=${JobFunctionId}`,
      method: "DELETE",
      dispatch,
    });
    refSnackbar.current.setOpenSnackBar();
    await fetchJobFunction();
  };
  const renderAfterCalled = useRef(false);
  const addEditModalRef = useRef();
  useEffect(() => {
    if (!renderAfterCalled.current) {
      fetchJobFunction();
    }
    renderAfterCalled.current = true;
  }, []);
  const columns = [
    {
      Text: "Job Function",
      Value: "JobFunction",
      style: { width: "25%" },
    },
    {
      Text: "Job Description",
      Value: "JobDescription",
    },
    {
      Text: "Action",
      cssClass: "text-center",
      style: { width: "100px", padding: "0px" },
      isVisiable: permission.ManageEdit || permission.ManageDelete,
      render: (dr) => (
        <>
        <div className="d-flex">
          <ActionButton
            onClick={(e) => fnEdit(dr.JobFunctionId)}
            disabled={!permission.ManageEdit}
            IconName="Edit"
            id="btnJobFunctionEdit"
          />

          <ActionButton
            onClick={(e) =>
              ref.current.confirmAlert(
                "Delete", //Confirm button text
                "Are You Sure", // Text if Alert
                "Do you want to delete " + MasterPageName, // Message of Alert
                dr.JobFunctionId // Endpoint to hit for delete
              )
            }
            disabled={!permission.ManageDelete}
            IconName="Delete"
            id="btnJobFunctionDelete"
          />
          <IconButton
            size="small"
            color="publish"
            title="Assign KRA"
            onClick={() => {
              assignStandardKRAToJobFunctionRef.current.openModal(
                dr.JobFunctionId
              );
            }}
          >
            <AssignmentIcon fontSize="small" />
          </IconButton>
        </div>
        </>
      ),
    },
  ];
  const [bData, setBData] = React.useState([
    {
      title: "Company",
      hrefLink: "#",
    },
    {
      title: "Manage Job Functions",
      hrefLink: "#",
    },
  ]);
  const MasterPageName = "Manage Job Functions";
  const confirmMessage = MasterPageName + " Deleted successfully";
  const AddButtonText = "Job Function";

  const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);
  return (
    <>
      <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
      <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />
      <StaticListComponent
        columns={columns}
        records={records}
        bData={bData}
        MasterPageName={MasterPageName}
        AddButtonText={AddButtonText}
        noRecordCss="p-0"
        BackBtnReturnPath={(state?.SourcePageName === StandardConst.ReturnPagePaths.ActionCenter) ? StandardConst.ReturnPagePaths.ActionCenter : ""}
        noRecordFound={
          <NoRecordTemplate
            headerValue={StandardConst.ManageJobFunctionheaderValueNoResults}
            subHeaderValue={StandardConst.ManageJobFunctionHeaderRole}
            imageUrl={StandardConst.imageNoRecordsFound}
            actionButton={
              <>
                {permission.ManageAdd && (
                  <Button variant="outline-primary" onClick={() => fnEdit(0)} id={`no_record_add_${AddButtonText}`}>
                    Add {AddButtonText}
                  </Button>
                )}
              </>
            }
          />
        }
        onAddEvent={() => fnEdit()}
        IsAddButtonVisible={permission?.ManageAdd}
        isSearchRequired={true}
        allowSerialNo={true}
      ></StaticListComponent>
      <AddEditJobFunction
        callBackEvent={() => fetchJobFunction()}
        ref={addEditModalRef}
      ></AddEditJobFunction>
      <AssignStandardKRAToJobFunctionComponent
        ref={assignStandardKRAToJobFunctionRef}
      ></AssignStandardKRAToJobFunctionComponent>
    </>
  );
};
export default JobFunction;
